import { Pipe, PipeTransform } from '@angular/core';
import { DeliveryProduct } from 'src/app/api/models';

@Pipe({
  name: 'onlyStaging',
})
export class OnlyStagingPipe implements PipeTransform {
  transform(value: DeliveryProduct[]): DeliveryProduct[] {
    return value.filter(item => !!item.staging_activities);
  }
}
